import React, { useEffect } from 'react'
import { ConnectVehicles } from 'src/Libs/e-mobility/vehicle-integration/components'
import VehicleManufacturersList from 'src/Libs/e-mobility/vehicle-integration/components/manufacturer-list/VehicleManufacturersList'
import { ADD_VEHICLE_ROUTE, CONNECT_VEHICLES_ROUTE, INSTALLATION_ID } from 'src/Libs/e-mobility/vehicle-integration/consts'
import { VehicleIntegration } from 'src/Libs/e-mobility/vehicle-integration'
import { Route, Routes } from 'react-router-dom'
import { ManufacturersProvider } from 'src/Libs/e-mobility/vehicle-integration/providers'

interface Props {
  installationId: string
}

/** Todo add lazy componets */
const VehicleIntegrationRoute: React.FC<Props> = ({ installationId }) => {
  /** We save the installationId here, because we need to send it to the backend in the near future whenever we send a request */
  useEffect(() => {
    localStorage.setItem(INSTALLATION_ID, installationId)
  }, [installationId])

  return (
    <ManufacturersProvider>
      <Routes>
        <Route path={`/${CONNECT_VEHICLES_ROUTE}`} element={<ConnectVehicles />} />
        <Route path={`/${ADD_VEHICLE_ROUTE}`} element={<VehicleManufacturersList />} />
        <Route path={`/`} element={<VehicleIntegration />} />
      </Routes>
    </ManufacturersProvider>
  )
}

export default VehicleIntegrationRoute
